import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type ProductPolicy = {
  product_policy_id?: number; // 상품정책 idx
  coupon_id?: number; // 쿠폰 idx
  promotion_id?: number; // 프로모션 idx
  product_g_id?: number; // 그룹상품 idx
  frequency_id?: number; // 프리퀀시 idx
  commission_rate?: number; // 수수료
  policy_type?: string; // 정책 타입
  is_show?: string; // 노출 여부
  discount_rate?: number; // 할인율/금액
  reserve_rate?: number; // 적립률
  discount_type?: string; // 할인타입
  reserve_type?: string; // 적립타입
  share_ratio?: number; // 분담비용
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ProductPolicy
   * --
   */
  getProductPolicies: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PRODUCT_POLICY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ProductPolicy
   * --
   */
  getProductPolicy: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PRODUCT_POLICY, {
        product_policy_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ProductPolicy
   * --
   */
  createProductPolicy: async (body: ProductPolicy) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PRODUCT_POLICY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ProductPolicy
   * --
   */
  updateProductPolicy: async (body: ProductPolicy) => {
    try {
      const { product_policy_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PRODUCT_POLICY, {
        product_policy_id: product_policy_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ProductPolicy
   * --
   */
  deleteProductPolicy: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PRODUCT_POLICY, {
        product_policy_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
